import React from 'react'
import { Checkbox, FormControlLabel, Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import { BUILDER_V2_INK, BUILDER_V2_MUTED_TEXT } from '../../util'

const useStyles = makeStyles<Theme, CheckboxOptionProps>(
  (theme) => ({
    root: {
      padding: theme.spacing(0.5, 0, 1)
    },
    controlLabel: {
      marginLeft: -9,
      marginRight: 0
    },
    checkbox: {
      padding: 6,
      color: BUILDER_V2_MUTED_TEXT
    },
    label: {
      fontSize: '.8125rem',
      fontWeight: 500,
      color: BUILDER_V2_INK
    },
    helperText: {
      // lines the helper text up with the label, past the checkbox
      paddingLeft: 27,
      fontSize: '.75rem',
      lineHeight: 1.4,
      color: BUILDER_V2_MUTED_TEXT
    }
  }),
  { name: 'CheckboxOption' }
)

export interface CheckboxOptionProps {
  classes?: StyleClasses<typeof useStyles>
  label: string
  helperText?: string
  checked: boolean
  onChange: (checked: boolean) => void
}

function CheckboxOption(props: CheckboxOptionProps) {
  const classes = useStyles(props)
  const { label, helperText, checked, onChange } = props

  return (
    <div className={classes.root}>
      <FormControlLabel
        classes={{ root: classes.controlLabel, label: classes.label }}
        control={
          <Checkbox
            classes={{ root: classes.checkbox }}
            // no size='small': the ui Checkbox's unchecked box is a fixed 24px, so only the checked
            // icon shrank, and the label jumped 4px on every tick (#25097)
            checked={checked}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
          />
        }
        label={label}
      />
      {helperText && <Typography className={classes.helperText}>{helperText}</Typography>}
    </div>
  )
}

export default CheckboxOption
